export default "__VITE_ASSET__DHzUE3WY__"